import React from 'react'
import image from "../images"
import "../css/footer.css"
import "../css/supportUs.css"
import { useNavigate } from 'react-router-dom'
import { useState } from "react"
import Navbar from "./Navbar"
import Footer from './Footer'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from 'react-responsive-carousel'
import axios from "axios";
import { useEffect } from 'react'
import { Checkmark } from 'react-checkmark'
import "../css/loading.css"
import RingLoader from "react-spinners/RingLoader"




function SupportUs() {

    const navigate = useNavigate();
    const[imageUrl,setImageUrl] = useState('')
    const[imageSelected,setImageSelected] = useState('')
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const [greentick, setGreentick] = useState(false);


    const [donation, setDonation] = useState({
        amount: '',
        dname: '',
        firstname: '',
        lastname: '',
        email: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        giftnote: ''
    })

    const handleButton = async (value) => {
        try {
          await axios.post(`https://petme.onrender.com/user/mailSender?email=${donation.email}`, { value });
          console.log('Email sent successfully');
        } catch (error) {
          console.error('Error sending email:', error);
        }
      }
  

    const handleSelect = async(event)=>{
        setImageSelected(event.target.files[0])
    }

    const HandleUpload = async () => {
        try {
            if (!imageSelected) {
                setError('No file selected');
                return;
            }

            const formData = new FormData();
            formData.append('image', imageSelected);

            const response = await axios.post('https://petme.onrender.com/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setImageUrl(response.data.imageUrl);

        } catch (error) {
            console.error('Error uploading image:', error);
            setError('Image upload failed');
        }
    };

    const handleChange = (e) => {

        const { name, value } = e.target
        setDonation({ ...donation, [name]: value })
    }

    const handleSubmit = async()=>{
        if(
            !donation.amount||
            !donation.dname||
            !donation.firstname||
            !donation.email||
            !donation.address1||
            !donation.city||
            !donation.state||
            !donation.country||
            !imageSelected
        ){
          window.alert("Please fill the fields")
        }else{
            setBusy(true)
            await HandleUpload();
        }
    }

    const donate = async () => {
        
        const { amount, dname, firstname, lastname, email, address1, address2, city, state, country, giftnote } = donation;
        const res = await fetch("https://petme.onrender.com/donation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                amount, dname, firstname, lastname, email, address1, address2, city, state, country, giftnote,imageUrl
            })
        });



        const data = await res.json();

        if (data.status === 422 || !data) {
            window.alert(data.error);
        } else {
            // window.alert(data.message)
            handleButton("donation")
            setTimeout(()=>{
                navigate("/Home");
            },3000)
        }

    }

    useEffect (()=>{

        if(imageUrl){
            donate()
            setBusy(false); 
            setGreentick(true)

        }

    },[imageUrl])


    if(busy){
        return(
          <div className="loader-container" >
        <RingLoader color="#36d7b7" loading size={90} />
        <h1 className="loading-heading">Please Wait....</h1>
      </div>
        )
      }
    
    if(greentick){
        return(
            <>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh', // Set to the desired height of the page
              }}>
                
                <div>
                <h1> <Checkmark size={100} />Donation Successfull</h1>
              </div>
              </div >
             
            </>
              
        )
    }

    return (

        <div>

            <Navbar />

            <Carousel>
                <div className="supportUs-slides">
                    <div className="slide-msg slide-1">
                        <p className="donation-msg">
                            Animals need your love.
                        </p>
                        <p className="donation-para">
                            By making a donation, you're not only giving hope, but also the promise of a brighter future. Your generosity ignites a chain reaction of love, empathy, and second chances. Together, we can transform lives and create stories of unconditional love.
                        </p>
                    </div>
                    <div className="supportUs-img support-pet-img">
                    </div>
                </div>

                <div className="supportUs-slides">
                    <div className="slide-msg slide-2">
                        <div className="donation-field">
                            <p className="donation-details donation-amount">Donation Amount</p>
                            <input id="donation" type="form" name="amount" value={donation.amount} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details in-name-of"> Donation in the Name of</p>
                            <input id="donation" type="form" name="dname" value={donation.dname} onChange={handleChange} className="donation-box in-name-of-box" placeholder="" />
                        </div>
                        {/* <div className="donation-field">
                            <p className="donation-details anonymousDonationOpt"> Anonymous Donation</p>
                            <input id="donation" type="form" name="dname"  className="donation-box anonymousDonationOpt-box" placeholder="(yes or no)" />
                        </div> */}
                        <div className="donation-field">
                            <p className="donation-details donation-first-name">First Name</p>
                            <input id="donation" type="form" name="firstname" value={donation.firstname} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details donation-last-name">Last Name</p>
                            <input id="donation" type="form" name="lastname" value={donation.lastname} onChange={handleChange} className="donation-box" placeholder="(Optional)" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details donation-email">Email Address</p>
                            <input id="donation" type="form" name="email" value={donation.email} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                    </div>
                    <div className="supportUs-img support-cat-img">
                    </div>
                </div>

                <div className="supportUs-slides">
                    <div className="slide-msg slide-3">
                        <div className="donation-field">
                            <p className="donation-details donation-add-1">Address Line 1</p>
                            <input id="donation" type="form" name="address1" value={donation.address1} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details donation-add-2">Address Line 2</p>
                            <input id="donation" type="form" name="address2" value={donation.address2} onChange={handleChange} className="donation-box" placeholder="(Optional)" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details donation-city">City</p>
                            <input id="donation" type="form" name="city" value={donation.city} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details donation-city">State</p>
                            <input id="donation" type="form" name="state" value={donation.state} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details donation-country">Country</p>
                            <input id="donation" type="form" name="country" value={donation.country} onChange={handleChange} className="donation-box" placeholder="" />
                        </div>
                        <div className="donation-field">
                            <p className="donation-details upload-donation-ss ">Please upload the screenshot of the donation</p>
                            <input id="donationForm" type="file" name="form" className="donation-box donation-ss-box" onChange={handleSelect} placeholder="" />
                        </div>
                    </div>
                    <div className="slide-image   support-QR-img">
                        <img className="QR-code-img" src={image.QR_Code} alt="QR-code-donation" />
                        <p className="scan-QR-code">Scan QR Code to make a donation</p>
                    </div>
                </div>

                <div className="supportUs-slides">                                                                                                                                                                                                                                                                                                                                                      
                    <div className="slide-msg slide-4">
                        <div className="donation-field">
                            <p className="donation-details donation-gift-note " >Gift Note</p>
                            <textarea id="donation" type="text" name="giftnote" value={donation.giftnote} onChange={handleChange} className="donation-box  gift-note-box" rows={4} cols={40} placeholder='(Optional)'/>
                            <button className="donation-form-btn" onClick={handleSubmit}>SUPPORT<img className="donation-btn-img" src={image.donationBtnImg} alt="animals-donation" /></button>
                        </div>
                    </div>
                    <div className="supportUs-img support-thanks-img">
                    </div>
                </div>
            </Carousel>

            <Footer />

        </div >
    );
};




export default SupportUs


